module.exports = __webpack_public_path__ + "media/images/patent/z_1-17cf98b4436a0a30c9a3967a2e3eff32.png";